import { Anchor } from '@repo/ui/src/components/Anchor';
import useProducts from '@hooks/product/useProducts';
import { IngredientProps } from '@repo/ui/src/types';
import { UnitOfMeasureEnum } from '@enums/recipe-enums';

interface RecipeStepIngredientProps {
  ingredient: IngredientProps;
  unitOfMeasure: number;
}

const RecipeStepIngredient = ({ ingredient, unitOfMeasure }: RecipeStepIngredientProps) => {
  const { products } = useProducts(
    ingredient?.ingredient?.product ? [ingredient?.ingredient?.product] : [],
  );
  const product = products[0];

  if (!ingredient) {
    return null;
  }

  const name = ingredient?.ingredient?.name;
  const link = product?.productUrl ?? ingredient.ingredient?.link?.link;

  const measurementDisplay =
    unitOfMeasure === UnitOfMeasureEnum.Imperial
      ? `${ingredient.imperial?.measurementDisplay || ''} ${ingredient.unitOfMeasure || ''}`
      : `${ingredient.metric?.measurementDisplay || ''} ${ingredient.metric?.unitOfMeasure || ''}`;

  return (
    <p className="tra-text-web-body-m">
      {measurementDisplay}&nbsp;
      {link ? (
        <Anchor
          className="tw-text-brand-300 tw-underline hover:tw-underline tw-cursor-pointer tw-inline"
          link={link}
        >
          {name}
        </Anchor>
      ) : (
        <span>{name}</span>
      )}
    </p>
  );
};

export default RecipeStepIngredient;
